(function () {
    // Load check
    if (!jQuery) {
        console.log('NOT LOADED!');
        return;
    }
    
    (function ($) {
        window.OferaCRM = window.OferaCRM || {};
        OferaCRM.FE = OferaCRM.FE || {};
        
        OferaCRM.FE.Product = {
            elements: {
                $priceTypeSelector: $("input[name='Product[price_type]']"),
                $locationField: $("#product-location"),
                $locationSelector: $("#product-auto"),
                $autosuggestList: $(".e-location-autosuggest"),
                $fileupload: $("#fileupload"),
                $sortableImages: $("#sortable_images"),
                $sliderContainer: $("#slider_container"),
                $showPhoneControls: $(".js-show-phone"),
                $sendMessage: $(".js-send-message"),
                $categoryModal: $("#category_modal"),
                $categoryListHolder: $(".js-category-list-holder"),
                $categoryModalBreadcrumbs: $(".js-category-breadcrumbs"),
                $sendReportButton: $(".js-send-report"),
                $form: $(".js-product__form"),
                $validateForm: $(".js-validate"),
                $priceSelector: $(".js-price-selector"),
                $priceValue: $(".js-price-value"),
                $transaction: $(".js-transaction"),
                $workingOnMessage: $(".js-working-on-ad")
            },
            
            reorderPictures: function () {
                var position = 1;
                $('.gallery-container').each(function (index) {
                    var $this = $(this);
                    var $order =  $(this).find('.order');
                    if ($this.hasClass('deleted')) {
                        $order.val('-');
                        return;
                    }
                    $order.val(position++);
                });
                return position;
            },
            
            loadCategoryListInModal: function (parentId) {
                var self = OferaCRM.FE.Product;
                self.elements.$categoryModal.find('.js-category-list-holder').html('');
                var list;
                if (!parentId) {
                    list = [];
                    for (var id in OferaCRM.BackendData.categories) {
                        if (OferaCRM.BackendData.categories[id].is_top) {
                            list.push(OferaCRM.BackendData.categories[id]);
                        };
                    }
                } else {
                    list = OferaCRM.BackendData.categories[parentId].children;
                }
                
                var output = '';
                list.forEach(function (cat) {
                    output += '<div class="col-xs-12 col-sm-6">';
                    output +=     '<div class="l-modal__category js-category-click" data-id="' + cat.id + '">';
                    output +=         '<table class="c-category">';
                    output +=             '<tbody>';
                    output +=                 '<tr>';
                    if (cat.is_top) {
                        output +=                 '<td class="c-category__image"><img src="./img/categories/' + cat.image + '" alt="" /></td>';
                    } else {
                        output +=                 '<td class="c-category__image"><i class="fa fa-chevron-right"></i></td>';
                    }
                    output +=                     '<td class="c-category__name">' + cat.name + '</td>';
                    output +=                 '</tr>';
                    output +=             '</tbody>';
                    output +=         '</table>';
                    output +=     '</div>';
                    output += '</div>';
                });
                
                self.elements.$categoryModal.find('.js-category-list-holder').html(output);
                
                var breadcrumbsArray = [];
                if (parentId){ 
                    var cat = OferaCRM.BackendData.categories[parentId];
                    breadcrumbsArray.unshift('<span>' + cat.name + '</span>');
                    
                    while (cat.parent_id) {
                        cat = OferaCRM.BackendData.categories[cat.parent_id];
                        breadcrumbsArray.unshift('<span data-id="' + cat.id + '" class="l-modal-body__breadcrumbs-link js-breadcrumb-link">' + cat.name + '</span>');
                    }
                    
                    breadcrumbsArray.unshift('<span data-id="0" class="l-modal-body__breadcrumbs-link js-breadcrumb-link"><i class="fa fa-home"></i></span>');
                }
                self.elements.$categoryModal.find('.js-category-breadcrumbs').html(breadcrumbsArray.join(' <i class="fa fa-chevron-right icon-binder"></i> '));
                if (breadcrumbsArray.length) {
                    self.elements.$categoryModal.find('.js-category-breadcrumbs').show();
                } else {
                    self.elements.$categoryModal.find('.js-category-breadcrumbs').hide();
                }
            }
        };
        
        if (OferaCRM.FE.Product.elements.$priceTypeSelector.length) {
            if ($("input[name='Product[price_type]'][checked]").val() !== 'VALUE') {
                $('.price-value').hide();
            }
            OferaCRM.FE.Product.elements.$priceTypeSelector.on('change', function () {
                if ($(this).val() === 'VALUE') {
                    $('.price-value').show();
                } else {
                    $('.price-value').hide();
                }
            });
        }
        
        if (OferaCRM.FE.Product.elements.$locationSelector.length) {
            OferaCRM.FE.Product.elements.$locationSelector.on('keyup', function () {
                var $this = $(this);
                var $locationAutosuggest = $('.e-location-autosuggest');

                if ($this.val().length < 3) {
                    $locationAutosuggest.html('');
                    return;
                }
                var searchTerm = $this.val().toUpperCase();
                searchTerm = searchTerm.replace(/Ă/g, 'A'); 
                searchTerm = searchTerm.replace(/Â/g, 'A'); 
                searchTerm = searchTerm.replace(/Î/g, 'I'); 
                searchTerm = searchTerm.replace(/Ș/g, 'S'); 
                searchTerm = searchTerm.replace(/Ț/g, 'T');

                var results = [];

                OferaCRM.localeData.forEach(function (county) {
                    county.loc.forEach(function (location) {
                        if (location.searchName.indexOf(searchTerm) === 0) {
                            results.push({
                                id: location.id,
                                name: location.proper,
                                isCounty: 0,
                                rang: location.rang,
                                displayName: '<span class="e-location-name">' + location.proper + '</span>' +
                                    '<span class="e-location-county">, județul ' + county.name + '</span>'
                            });
                        }
                    });
                });

                results.sort(function (a, b) {
                    if (a.rang > b.rang) {
                        return 1;
                    }

                    if (a.rang < b.rang) {
                        return -1;
                    }

                    return a.name > b.name;
                });

                var displayedResults = results.splice(0,7);

                $locationAutosuggest.html('');
                displayedResults.forEach(function (result) {
                    $locationAutosuggest.append('<li class="b-suggestion" data-id="' + result.id + '" data-name="' + result.name + '">' + result.displayName + '</li>');
                });
            });
        }

        if (OferaCRM.FE.Product.elements.$autosuggestList.length) {
            OferaCRM.FE.Product.elements.$autosuggestList.on('click', 'li', function () {
                var $this = $(this);
                OferaCRM.FE.Product.elements.$locationSelector.val($this.data('name'));
                OferaCRM.FE.Product.elements.$locationField.val($this.data('id'));
                $('.e-location-autosuggest').html('');

                var $locationName = $(".js-location-name");
                $locationName.removeClass('has-error');
                $locationName.addClass('has-success');
                $locationName.find('.help-block').html('');
            });
        }
        
        $.ajax({
            url: BASE_URL + '/category/list',
            method: 'GET',
            dataType: 'json'
        }).done(function(data) {
            
            OferaCRM.BackendData = OferaCRM.BackendData || {};
            OferaCRM.BackendData.categories = [];
            
            for (var id in data) {
                if (data[id].parent_id > 0) {
                    // Inactive parents may stump the inactive children
                    if (data[data[id].parent_id]) {
                        if (data[data[id].parent_id].children) {
                            data[data[id].parent_id].children.push(data[id]);
                        } else {
                            data[data[id].parent_id].children = [data[id]];
                        }
                    }
                }
            } 
            
            OferaCRM.BackendData.categories = data;
        }).fail(function(error) {
            console.log(error.responseText);
        });

        $(document).ready(function () {
            
            var self = OferaCRM.FE.Product;
            var E = self.elements;
            
            if (OferaCRM.FE.Product.elements.$sortableImages.length) {
                OferaCRM.FE.Product.elements.$sortableImages.sortable();
                OferaCRM.FE.Product.elements.$sortableImages.disableSelection();        
                OferaCRM.FE.Product.elements.$sortableImages.on('sortstop', OferaCRM.FE.Product.reorderPictures);
                
                OferaCRM.FE.Product.elements.$sortableImages.on('click', 'span.deleted', function() {
                    var $this = $(this);
                    var $holder = $this.closest('.gallery-container');

                    var $input = $holder.find('input.deleted');
                    if ($holder.hasClass('deleted')) {
                        $input.val('0');
                        $holder.removeClass('deleted');
                        OferaCRM.FE.Product.reorderPictures();
                        return;
                    }

                    $input.val('1');
                    $holder.addClass('deleted');
                    OferaCRM.FE.Product.reorderPictures();
                });
            }
            
            if (OferaCRM.FE.Product.elements.$locationField.length) {
                var locationId = parseInt(OferaCRM.FE.Product.elements.$locationField.val(), 10);
                var locationName = '';
                
                for (var i = 0; i < OferaCRM.localeData.length; i++) {
                    for (var j = 0; j < OferaCRM.localeData[i].loc.length; j++) {
                        if (OferaCRM.localeData[i].loc[j].id === locationId) {
                            locationName = OferaCRM.localeData[i].loc[j].name;
                            break;
                        }
                    }
                    if (locationName !== '') {
                        break;
                    }
                }
                OferaCRM.FE.Product.elements.$locationSelector.val(locationName);
            }
            
            if (OferaCRM.FE.Product.elements.$fileupload.length) {
                OferaCRM.FE.Product.elements.$fileupload.fileupload({
                    url: BASE_URL + "/product/upload-image",
                    dataType: 'json',
                    autoUpload: true,
                    acceptFileTypes: /(\.|\/)(gif|jpe?g|png)$/i,
                    maxFileSize: 999000,
                    // Enable image resizing, except for Android and Opera,
                    // which actually support image resizing, but fail to
                    // send Blob objects via XHR requests:
                    disableImageResize: /Android(?!.*Chrome)|Opera/
                        .test(window.navigator.userAgent),
                    previewMaxWidth: 90,
                    previewMaxHeight: 75,
                    previewCrop: true
                }).on('fileuploadadd', function (e, data) {
                    //ImobCRM.Debug.log(self.showLogs, 'bindImageUpload', 'File has been added');
                    data.context = $('<div class="gallery-container ui-sortable-handle" />').insertBefore('#file_upload_button');
                    $.each(data.files, function (index, file) {
                        var node = $('<span class="control deleted" title="Șterge"><i class="fa fa-trash"></i></span>');
                        node.appendTo(data.context);
                    });
                }).on('fileuploadprocessalways', function (e, data) {
                    var index = data.index,
                        file = data.files[index],
                        node = $(data.context.children()[index]);
                    if (file.preview) {
                        // Reordering the pictures will give the total number of container (INCLUDING THIS ONE: hence -1)
                        node.parent().prepend('<input type="text" class="order" value="' + (OferaCRM.FE.Product.reorderPictures() - 1) + '" name="Product[imageOrders][]" />');
                        node.parent().prepend('<input type="hidden" class="deleted" name="Product[imageDeleted][]" />');
                        node.parent().prepend('<div class="image-upload-bar"><div class="progress-bar progress-bar-success" style="width: 0;" /></div>');
                        node.parent().prepend('<input type="text" readonly="readonly" value="0%" class="image-upload-progress-number" />');
                        node.parent().prepend('<input type="hidden" value="" name="Product[imageNames][]" class="image-name-after-upload" />');
                        node.parent().prepend($('<div class="image-container" style="width: ' + 90 + 'px; height: ' + 75 + 'px;" />').html(file.preview));
                    }
                    if (file.error) {
                        node
                            .append('<br>')
                            .append($('<span class="text-danger"/>').text(file.error));
                    }
                    if (index + 1 === data.files.length) {
                        data.context.find('button')
                            .text('Upload')
                            .prop('disabled', !!data.files.error);
                    }
                }).on('fileuploadprogress', function (e, data) {
                    var progress = parseInt(data.loaded / data.total * 100, 10);
                    $(data.context).find('.progress-bar').css(
                        'width',
                        progress + '%'
                    );
                    $(data.context).find('.image-upload-progress-number').val(progress + '%');
                }).on('fileuploaddone', function (e, data) {
                    $.each(data.result.files, function (index, file) {
                        $(data.context).find('.image-name-after-upload').val(file);
                    });
                }).on('fileuploadfail', function (e, data) {
                    $.each(data.files, function (index) {
                        $(data.context).find('.image-upload-progress-number').val('!').addClass('error');
                        $(data.context).find('.image-container').css('opacity', '0.15');
                    });
                    $("#oferte_can_submit").val('yes');
                }).prop('disabled', !$.support.fileInput)
                    .parent().addClass($.support.fileInput ? undefined : 'disabled');
            }
            
            if (OferaCRM.FE.Product.elements.$sliderContainer.length) {
                var options = {
                    $AutoPlay: 0,                                       //[Optional] Auto play or not, to enable slideshow, this option must be set to greater than 0. Default value is 0. 0: no auto play, 1: continuously, 2: stop at last slide, 4: stop on click, 8: stop on user navigation (by arrow/bullet/thumbnail/drag/arrow key navigation)
                    $AutoPlaySteps: 1,                                  //[Optional] Steps to go for each navigation request (this options applys only when slideshow disabled), the default value is 1
                    $FillMode: 2,                                       //[Optional] Allow for panoramic and vertical pictures to be displayed to scale
                    $Idle: 2000,                                        //[Optional] Interval (in milliseconds) to go for next slide since the previous stopped if the slider is auto playing, default value is 3000
                    $PauseOnHover: 1,                                   //[Optional] Whether to pause when mouse over if a slider is auto playing, 0 no pause, 1 pause for desktop, 2 pause for touch device, 3 pause for desktop and touch device, 4 freeze for desktop, 8 freeze for touch device, 12 freeze for desktop and touch device, default value is 1

                    $ArrowKeyNavigation: 1,   			        //[Optional] Steps to go for each navigation request by pressing arrow key, default value is 1.
                    $SlideEasing: $Jease$.$OutQuint,                    //[Optional] Specifies easing for right to left animation, default value is $Jease$.$OutQuad
                    $SlideDuration: 1500,                                //[Optional] Specifies default duration (swipe) for slide in milliseconds, default value is 500
                    $MinDragOffsetToSlide: 20,                          //[Optional] Minimum drag offset to trigger slide, default value is 20
                    //$SlideWidth: 600,                                 //[Optional] Width of every slide in pixels, default value is width of 'slides' container
                    //$SlideHeight: 300,                                //[Optional] Height of every slide in pixels, default value is height of 'slides' container
                    $SlideSpacing: 0, 					                //[Optional] Space between each slide in pixels, default value is 0
                    $UISearchMode: 1,                                   //[Optional] The way (0 parellel, 1 recursive, default value is 1) to search UI components (slides container, loading screen, navigator container, arrow navigator container, thumbnail navigator container etc).
                    $PlayOrientation: 1,                                //[Optional] Orientation to play slide (for auto play, navigation), 1 horizental, 2 vertical, 5 horizental reverse, 6 vertical reverse, default value is 1
                    $DragOrientation: 1,                                //[Optional] Orientation to drag slide, 0 no drag, 1 horizental, 2 vertical, 3 either, default value is 1 (Note that the $DragOrientation should be the same as $PlayOrientation when $Cols is greater than 1, or parking position is not 0)

                    $ArrowNavigatorOptions: {                           //[Optional] Options to specify and enable arrow navigator or not
                        $Class: $JssorArrowNavigator$,                  //[Requried] Class to create arrow navigator instance
                        $ChanceToShow: 2,                               //[Required] 0 Never, 1 Mouse Over, 2 Always
                        $Steps: 1                                       //[Optional] Steps to go for each navigation request, default value is 1
                    },

                    $BulletNavigatorOptions: {                          //[Optional] Options to specify and enable navigator or not
                        $Class: $JssorBulletNavigator$,                 //[Required] Class to create navigator instance
                        $ChanceToShow: 2,                               //[Required] 0 Never, 1 Mouse Over, 2 Always
                        $Steps: 1,                                      //[Optional] Steps to go for each navigation request, default value is 1
                        $SpacingX: 12,                                  //[Optional] Horizontal space between each item in pixel, default value is 0
                        $Orientation: 1                                 //[Optional] The orientation of the navigator, 1 horizontal, 2 vertical, default value is 1
                    }
                };

                var jssor_slider1 = new $JssorSlider$(OferaCRM.FE.Product.elements.$sliderContainer.attr('id'), options);

                //responsive code begin
                //you can remove responsive code if you don't want the slider scales while window resizing
                function ScaleSlider() {
                    var parentWidth = jssor_slider1.$Elmt.parentNode.clientWidth;
                    if (parentWidth) {
                        jssor_slider1.$ScaleWidth(parentWidth);
                    }
                    else
                        window.setTimeout(ScaleSlider, 30);
                }
                ScaleSlider();

                $(window).bind("load", ScaleSlider);
                $(window).bind("resize", ScaleSlider);
                $(window).bind("orientationchange", ScaleSlider);
                //responsive code end
            }
            
            if (OferaCRM.FE.Product.elements.$showPhoneControls.length) {
                OferaCRM.FE.Product.elements.$showPhoneControls.on('click', function () {
                    var $this = $(this);
                    $this.removeClass('c-product-view__right-button--with-show-phone');
                    $this.removeClass('js-show-phone');
                    $this.find('.js-loader').removeClass('hidden');
                    
                    $.ajax({
                        url: BASE_URL + '/anunt/telefon/' + $this.data('id'),
                        method: 'GET',
                        dataType: 'json'
                    })
                    .done(function (data) {
                        $this.find('.js-phone-number').html(data.phone);
                        $this.find('.js-phone-call').attr('href', 'tel:' + data.phone).html(data.phone);
                        $this.find('.js-show-phone-link').remove();
                        $this.find('.js-loader').addClass('hidden');
                    })
                    .fail(function (err) {
                        console.log('Could not get phone!');
                    });
                    
                });
            }
            
            if (OferaCRM.FE.Product.elements.$sendMessage.length) {
                OferaCRM.FE.Product.elements.$sendMessage.on('click', function () {
                    var $this = $(this);
                    var $form = $this.closest('.js-contact-form');
                    var message = {
                        subject: 'Contact ad: ' + $form.data('id'),
                        content: $form.find('.js-message-content').val(),
                        owner: $form.data('owner'),
                        sender: $form.data('sender'),
                        index: 0,
                        product_id: $form.data('id')
                    };
                    
                    $.ajax({
                        url: BASE_URL + '/message/create-ajax',
                        method: 'POST',
                        dataType: 'json',
                        data: {
                            Message: message
                        }
                    })
                    .done(function (data) {
                        if (data.message === 'success') {
                            $form.html('Mesajul a fost trimis!');
                        }
                    })
                    .fail(function (err) {
                        console.log(err);
                    });
                });
            }
            
            if (OferaCRM.FE.Product.elements.$categoryListHolder.length) {
                OferaCRM.FE.Product.elements.$categoryListHolder.on('click', '.js-category-click', function () {
                    var $this = $(this);
                    var categoryObject = OferaCRM.BackendData.categories[$this.data('id')];
                    
                    if (categoryObject.children && categoryObject.children.length) {
                        OferaCRM.FE.Product.loadCategoryListInModal(categoryObject.id);
                    } else {
                        $("#product-category_id").val(categoryObject.id);
                        var breadcrumbsArray = [];
                        var cat = OferaCRM.BackendData.categories[categoryObject.id];
                        breadcrumbsArray.unshift('&nbsp;' + cat.name );

                        while (cat.parent_id) {
                            cat = OferaCRM.BackendData.categories[cat.parent_id];
                            breadcrumbsArray.unshift('&nbsp;' + cat.name);
                        }
                        var output = '<img class="c-product__category-main-image" src="./img/categories/' + cat.image + '" alt="" />';
                        output += breadcrumbsArray.join('&nbsp;&rarr;');
                        output += '&nbsp;<div class="c-button" data-toggle="modal" data-target="#category_modal">Schimbă</div>';
                        $(".js-product__category-name").html(output);
                        
                        OferaCRM.FE.Product.elements.$categoryModal.modal('hide');
                        
                        $.ajax({
                            url: BASE_URL + '/category/properties-ajax/' + categoryObject.id,
                            method: 'GET'
                        })
                        .done(function (data) {
                            $('.js-dynamic-properties').html(data);
                        })
                        .fail(function (err) {
                            console.log(err);
                        });

                        $.ajax({
                            url: BASE_URL + '/category/layout-ajax/' + categoryObject.id,
                            method: 'GET',
                            dataType: 'json'
                        })
                        .done(function (data) {
                            if (!data.price) {
                                E.$transaction.hide();
                                $('input[name="Product[price_type]"]:checked').prop('checked', false);
                            } else {
                                E.$transaction.show();
                                
                                var $selected;
                                var $priceFREERadio = $('input[name="Product[price_type]"][value="FREE"]');
                                if (data.price.indexOf('FREE') >= 0) {
                                    $priceFREERadio.closest('.js-select-box').show();
                                    $selected = $priceFREERadio;
                                } else {
                                    $priceFREERadio.closest('.js-select-box').hide();
                                }
                                var $priceVALUERadio = $('input[name="Product[price_type]"][value="VALUE"]');
                                if (data.price.indexOf('VALUE') >= 0) {
                                    $priceVALUERadio.closest('.js-select-box').show();
                                    $selected = $priceVALUERadio;
                                    $('.price-value').show();
                                } else {
                                    $priceVALUERadio.closest('.js-select-box').hide();
                                    $('.price-value').hide();
                                }
                                var $priceEXCHANGERadio = $('input[name="Product[price_type]"][value="EXCHANGE"]');
                                if (data.price.indexOf('EXCHANGE') >= 0) {
                                    $priceEXCHANGERadio.closest('.js-select-box').show();
                                    if (data.price.indexOf('VALUE') < 0) {
                                        $selected = $priceEXCHANGERadio;
                                    }
                                } else {
                                    $priceEXCHANGERadio.closest('.js-select-box').hide();
                                }

                                $('input[name="Product[price_type]"]:checked').prop('checked', false);
                                E.$priceSelector.find('.js-select-box').removeClass('selected');

                                if ($selected && $selected.length > 0) {
                                    $selected.closest('.js-select-box').addClass('selected');
                                    $selected.prop('checked', true);
                                }
                            }
                    
                            if (typeof(data.status_type) !== undefined) {
                                var $statusTypes = $("#product-status_value");
                                var output = '';
                                if (data.status_type && data.status_type.options) {
                                    var statusTypesArray = data.status_type.options.split('|');
                                    statusTypesArray.forEach(function (st) {
                                        output += '<option value="' + st + '">' + st + '</option>';
                                    });
                                }
                                $statusTypes.html(output);
                                if (!output) {
                                    $statusTypes.closest('.form-group').hide();
                                } else {
                                    $statusTypes.closest('.form-group').show();
                                }
                            }
                        })
                        .fail(function (err) {
                            console.log(err);
                        });
                    }
                });
            }
            
            if (OferaCRM.FE.Product.elements.$categoryModal.length) {
                OferaCRM.FE.Product.elements.$categoryModal.on('show.bs.modal', function () {
                    OferaCRM.FE.Product.loadCategoryListInModal();
                });
            }
            
            if (OferaCRM.FE.Product.elements.$categoryModalBreadcrumbs.length) {
                OferaCRM.FE.Product.elements.$categoryModalBreadcrumbs.on('click', '.js-breadcrumb-link', function () {
                    var $this = $(this);
                    OferaCRM.FE.Product.loadCategoryListInModal($this.data('id'));
                });
            }
            
            if (OferaCRM.FE.Product.elements.$sendReportButton.length) {
                OferaCRM.FE.Product.elements.$sendReportButton.on('click', function () {
                    var $this = $(this);
                    var reportId = $("input[name=report-ad]:checked").val();
                    if (!reportId) {
                        alert('Vă rog selectați motivul pentru raportare!')
                        return;
                    }
                    
                    $.ajax({
                        url: BASE_URL + '/anunt/raporteaza/' + $this.data('id') + '/' + reportId,
                        method: 'POST',
                        dataType: 'json'
                    })
                    .done(function (data) {
                        if (data.message === 'OK') {
                            alert('Anunțul a fost raportat!');
                            $("#report_modal").modal('hide');
                        } else {
                            alert('Anunțul nu a putut fi raportat!');
                        }
                    })
                    .fail(function (err) {
                        console.log(err);
                        alert('Anunțul nu a putut fi raportat!');
                    });
                });
            }
            
            if (OferaCRM.FE.Product.elements.$validateForm.length) {
            }
            
            if (E.$form.length > 0) {
                
                // Add extra validation rules for custom fields
                E.$form.on('afterValidate', function () {
                    var $categoryName = $(".js-product__category-name");
                    var $formGroup = $categoryName.closest('.form-group');
                    
                    if(!$("#product-category_id").val()) {
                        $formGroup.addClass('has-error');
                        $formGroup.find('.help-block').html('&laquo;Categoria&raquo; trebuie selectată.')
                    } else {
                        $formGroup.removeClass('has-error');
                        $formGroup.addClass('has-success');
                        $formGroup.find('.help-block').html('')
                    }
                    
                    var $locationName = $(".js-location-name");
                    if(!$("#product-location").val()) {
                        $locationName.addClass('has-error');
                        $locationName.find('.help-block').html('&laquo;Localitatea&raquo; trebuie selectată.');
                    }

                    // Check for errors in the form
                    if (!$(this).find('.has-error').length) {
                        E.$validateForm.attr('disabled', 'disabled');
                        E.$validateForm.addClass('disabled');
                        E.$workingOnMessage.show();
                        return true;
                    }
                    E.$validateForm.removeAttr('disabled');
                    E.$validateForm.removeClass('disabled');
                    E.$workingOnMessage.hide();
                    return false;
                });

                // Validate location and category
                E.$form.on('beforeSubmit', function () {
                
                    var haveErrors = false;
                    
                    if(!$("#product-category_id").val()) {
                        haveErrors = true;
                    }
                    
                    if(!$("#product-location").val()) {
                        haveErrors = true;
                    }
                    
                    return !haveErrors;
                });
            }
            
            if (E.$priceSelector.length > 0) {
                E.$priceSelector.on('click', '.js-select-box', function () {
                    var $this = $(this);
                    
                    if ($this.hasClass('selected')) {
                        return;
                    }
                    
                    E.$priceSelector.find('.js-select-box').removeClass('selected');
                    $this.addClass('selected');
                    
                    E.$priceSelector.find("input[name='Product[price_type]']").prop('checked', false);
                    $this.find("input[name='Product[price_type]']").prop('checked', true);

                    if ($this.find("input[name='Product[price_type]']").val() === 'VALUE') {
                        $('.price-value').show();
                    } else {
                        $('.price-value').hide();
                    }
                });
            }
        });
    })(jQuery);
})();